import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
}
export function Reveal({
  children,
  delay = 0,
  className = '',
  as = 'div'
}: RevealProps) {
  const reduced = useReducedMotion();
  const Component = motion[as];
  if (reduced) {
    return <Component className={className} data-id="element-295" data-mp="3gijsmqndxrzt">{children}</Component>;
  }
  return <Component className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-296" data-mp="2js9glbtcvigi">
      {children}
    </Component>;
}